var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 8,
  viewBox: "0 0 14 8",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M10 7.003c0 .55-.456.997-.995.997H.995A1 1 0 0 1 0 7.003V.997C0 .447.456 0 .995 0h8.01A1 1 0 0 1 10 .997V2.31L13.082.982c.507-.219.918.052.918.612v4.812c0 .556-.413.83-.918.612L10 5.69z"
})));
export default SvgVideoCamera;